// extracted by mini-css-extract-plugin
export default {"form_control":"ModalHireMeForm_form_control__YA9vc","form_control__submit":"ModalHireMeForm_form_control__submit__N04r8","form__footer":"ModalHireMeForm_form__footer__3BXxg"};